import type { LanguageCode } from '@alltrails/types/LanguageCode';
import type { LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';
import { useLanguageRegionCode } from './useLanguageRegionCode';

export function useLanguageCode(): LanguageCode {
  const languageRegionCode: LanguageRegionCode = useLanguageRegionCode();
  return languageRegionCode.split('-')[0] as LanguageCode;
}
